export default {
  INACTIVE: 1,
  ACTIVE: 0,
};
